var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconQuestionBlank = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.11 2H6a1.89 1.89 0 00-1.9 1.89v11.82A1.89 1.89 0 006 17.46h1.93v-.12a6.42 6.42 0 01-.51 2.2L6.37 22l2.4-1.17.28-.14a11.78 11.78 0 003.33-3l.17-.22H18a2 2 0 002-1.85V3.88A1.91 1.91 0 0018.11 2zM18 4v11.5h-5.51a1.87 1.87 0 00-1.38.67l-.22.27c-.28.35-.57.68-.88 1l-.01.06v-.14a2 2 0 00-.47-1.28l-.2-.08a1.82 1.82 0 00-1.22-.51h-2V4z"
})));

export default SvgIconQuestionBlank;